import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import logger from "redux-logger";
import thunk from "redux-thunk";

import {
  persistStore,
  persistReducer,
  FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER
} from "redux-persist";
import localForage from "localforage";

import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import loginReducer from "../Pages/Login/sliceUsers";
import grnModelCheckboxReducer from "../Pages/Grn/sliceGrnCheckout";
import GrnHeadSlice from "../Pages/Grn/SliceGRNHead";
import GrnDetailSlice from "../Pages/Grn/SliceGRNDetail";
import GrnNavBtnSlice from "../Pages/Grn/SliceGRNNavBtn";
import GRNConfigurationSlice from "../Pages/Grn/SliceGRNConfiguration";
import GRNLocationSlice from "../DBSlice/SliceGRNLocation";
import GRNLocationGroupSlice from "../DBSlice/SliceGRNLocationGroup";
import GRNSlice from "../DBSlice/SliceTax";
import GRNDetailValidatorSlice from "../Pages/Grn/SliceGRNDetailValidator";
import BinSlice from "../DBSlice/SliceBin";
import BinTransferSlice from "../Pages/BinTransfer/SliceBinTransfer";
import InstantPickingHeadSlice from "../Pages/Instant/SliceInstantPickingHead";
import PickingHeadSlice from "../Pages/Picking/SlicePickingHead";
import SliceWmsPhysicalStockCount from "../Pages/WmsPhysicalStockCount/SliceWmsPhysicalStockCount";
import SliceWmsPoPhysicalStockCount from "../Pages/WmsPoPhysicalStockCount/SliceWmsPoPhysicalStockCount";
import SliceCyclecount from "../Pages/CycleCount/SliceCyclecount";
import SlicePhysicalStock from "../Pages/PhysicalStock/SlicePhysicalStock";
import SliceStockTransferReceipt from "../Pages/StockTransferReceipt/SliceStockTransferReceipt";
import SlicePutAway from "../Pages/PutAway/SlicePutAway";
import SliceEasyPutAway from "../Pages/EasyPutAway/SliceEasyPutAway";
import SliceNotification from "../Pages/Notification/SliceNotification";
import SliceDispatch from "../Pages/Dispatch/SliceDispatch";
import SliceEasyBinTransfer from "../Pages/EasyBinTransfer/SliceEasyBinTransfer";
import SliceLoading from "../Pages/Loading/SliceLoading";
import SliceEasyLoading from "../Pages/EasyLoading/SliceEasyLoading";
import WmsInvoiceSlice from "../Pages/WMSSalesInvoice/SliceWmsInvoice";
import SalesQuotation from "../Pages/SalesQuotation/SliceSalesQuotation";
import SalesOrder from "../Pages/SalesOrder/SliceSalesOrder";
import SliceSalesInvoice from "../Pages/SalesInvoice/SliceSalesInvoice";
import SliceSalesReturn from "../Pages/SalesReturn/SliceSalesReturn";
import SliceDelieveryNote from "../Pages/DelieveryNote/SliceDelieveryNote";
import WmsInvoiceTagSlice from "../Pages/WMSSalesInvoice/sliceWmsInvoiceTag";
import SliceWmsInboundGRN from "../Pages/InboundGRN/SliceWmsInboundGRN";
import SliceGRNNormal from "../Pages/GRNNormal/SliceGRNNormal";
import SlicePurchaseOrder from "../Pages/PurchaseOrder/SlicePurchaseOrder";
import SliceWmsOutboundGRV from "../Pages/OutboundGRV/SliceWmsOutboundGRV";
import SliceGRV from "../Pages/GRV/SliceGRV";
import SliceWmsStockAdjustment from "../Pages/StockAdjustment/SliceWmsStockAdjustment";
import SliceWmsLoadingReceipt from "../Pages/LoadingReceipt/SliceWmsLoadingReceipt";
import SliceWmsStockTransfer from "../Pages/StockTransfer/SliceWmsStockTransfer";
import SliceStockTransfer from "../Pages/StockTransferNormal/SliceStockTransfer";
import SliceStockAdjustment from "../Pages/StockAdjustmentNormal/SliceStockAdjustment";
import Slicebin from "../Pages/bin/Slicebin";
import SliceDriver from "../Pages/Driver/SliceDriver";
import SliceTruck from "../Pages/Truck/SliceTruck";
import SliceWMSStockReport from "../Pages/WMSStockReport/SliceWMSStockReport";
import SliceWMSSalesReport from "../Pages/WMSSalesReport/SliceWMSSalesReport";
import SlicePendingDoDetailReport from "../Pages/PendingDoDetailReport/SlicePendingDoDetailReport";
import SliceTransDetailReport from "../Pages/TransDetailReport/SliceTransDetailReport";
import SliceBinTransferReport from "../Pages/BinTransferReport/SliceBinTransferReport";
import SliceDcCostCompareHistoryReport from "../Pages/DcCostCompareHistoryReport/SliceDcCostCompareHistoryReport";
import SliceOutletPlanningReport from "../Pages/OutletPlanningReport/SliceOutletPlanningReport";
import SliceLoadingList from "../Pages/LoadingList/SliceLoadingList";
import SliceDCRequest from "../Pages/DCRequest/SliceDCRequest";
import SliceDB from "../DBSlice/SliceDB";
import sliceOrderTakingCar from "../Pages/orderTakingFromCar/sliceOrderTakingCar";
import sliceCart from "../Pages/cart/sliceCart";
import SliceBatchOut from "../Pages/BatchOut/SliceBatchOut";
// Faroooq
import GRNBinTransferReasonSlice from "../DBSlice/SliceGRNBinTransferReason";
import SliceWmsDashboard from "../Pages/WmsDashboard/SliceWmsDashboard";
import SliceDelivery from "../Pages/Delivery/SliceDelivery";
import SliceSegregation from "../Pages/Segregation/SliceSegregation";
import SliceWHPicking from "../Pages/WHPicking/SliceWHPicking";
import SliceBarcodeScanning from "../Pages/BarcodeScanning/SliceBarcodeScanning";
import SliceVendorCreditNote from "../Pages/VendorCreditNote/SliceVendorCreditNote";
import SliceItemCreationRequest from "../Pages/ItemCreationRequest/SliceItemCreationRequest";
import SliceItemApproveRequest from "../Pages/ItemApprove/SliceItemApproveRequest";
import SliceCyclicPhysicalStockSetting from "../Pages/CycleCountSetting/SliceCyclicPhysicalStockSetting";
import SliceCyclicPhysicalStockCounting from "../Pages/CycleCountCounting/SliceCyclicPhysicalStockCounting";
import SliceWmsInboundVendor from "../Pages/WmsInboundVendor/SliceWmsInboundVendor";
import SliceWmsInboundReturn from "../Pages/WmsInboundReturn/SliceWmsInboundReturn";
import SliceWmsInboundOutlet from "../Pages/WmsInboundOutlet/SliceWmsInboundOutlet";
import SliceStockTransferRequest from "../Pages/StockTransferRequest/SliceStockTransferRequest";
import SliceStockSetupChangeRequest from "../Pages/StockSetupChangeRequest/SliceStockSetupChangeRequest";
import SliceStockSetupChangeApprove from "../Pages/StockSetupChangeApprove/SliceStockSetupChangeApprove";
import SliceVendorDiscontinueChangeRequest from "../Pages/VendorDiscontinueChangeRequest/SliceVendorDiscontinueChangeRequest";
import SliceVendorDiscontinueChangeApprove from "../Pages/VendorDiscontinueChangeApprove/SliceVendorDiscontinueChangeApprove";
import SliceItemListApprove from "../Pages/ItemListApprove/ItemListApproveSlice";
import SliceItemListRequest from "../Pages/ItemListingRequest/SliceItemListingDetail";
import SliceMoqRequest from "../Pages/ItemMoqRequest/SliceMoqDetail";
import SliceMOQApprove from "../Pages/ItemMOQApprove/MOQApproveSlice";
import SliceRSPChangeRequest from "../Pages/RSPChangeRequest/SliceRSPChangeRequest";
import SliceIMPurchaseRequest from "../Pages/ImportPurchasePlanning/SliceImportPuchaseRequest";
import SlicePickingList from "../Pages/PickingList/SlicePickingList";
// add the reducers that need to be persisted
const reducersToPersist = [
  "login",
  "grnModelCheckbox",
  "GrnModelSearchTableObj",
  "SliceGRNHead",
  "SliceGRNDetail",
  "GRNConfiguration",
  "SliceGRNLocation",
  "SliceGRNLocationGroup",
  "SliceGRN",
  "SliceGRNBinTransferReason",
  "SliceBin",
  "SliceDriver",
  "SliceWmsDashboard",
  "SliceTruck",
  "SliceBinTransfer",
  "SliceInstantPickingHead",
  "SlicePickingHead",
  "SliceDispatch",
  "SliceEasyBinTransfer",
  "SliceNotification",
  "SliceLoading",
  "SliceEasyLoading",
  "SliceWmsInvoice",
  "SliceSalesQuotation",
  "SliceSalesOrder",
  "SliceSalesInvoice",
  "SliceSalesReturn",
  "SliceDelieveryNote",
  "sliceWmsInvoiceTag",
  "SliceWmsInboundGRN",
  "SliceGRNNormal",
  "SlicePurchaseOrder",
  "SliceWmsOutboundGRV",
  "SliceGRV",
  "SliceWmsStockAdjustment",
  "SliceWmsStockTransfer",
  "SliceStockTransfer",
  "SliceStockAdjustment",
  "SliceWmsLoadingReceipt",
  "Slicebin",
  "SliceDriver",
  "SliceWmsDashboard",
  "SliceTruck",
  "SliceWMSStockReport",
  "SliceWMSSalesReport",
  "SlicePendingDoDetailReport",
  "SliceTransDetailReport",
  "SliceBinTransferReport",
  "SliceDcCostCompareHistoryReport",
  "SliceOutletPlanningReport",
  "SliceLoadingList",
  "SliceDCRequest",
  "SliceDB",
  "SliceWmsPhysicalStockCount",
  "SliceWmsPoPhysicalStockCount",
  "SliceCyclecount",
  "SlicePhysicalStock",
  "SliceStockTransferReceipt",
  "SlicePutAway",
  "SliceEasyPutAway",
  "SliceDelivery",
  "SliceSegregation",
  "SliceWHPicking",
  "SliceBarcodeScanning",
  "sliceOrderTakingCar",
  "sliceCart",
  "SliceVendorCreditNote",
  "SliceBatchOut",
  "SliceItemCreationRequest",
  "SliceItemApproveRequest",
  "SliceCyclicPhysicalStockSetting",
  "SliceCyclicPhysicalStockCounting",
  "SliceWmsInboundVendor",
  "SliceWmsInboundReturn",
  "SliceWmsInboundOutlet",
  "SliceStockTransferRequest",
  "SliceStockSetupChangeRequest",
  "SliceStockSetupChangeApprove",
  "SliceVendorDiscontinueChangeRequest",
  "SliceVendorDiscontinueChangeApprove",
  "SliceItemListApprove",
  "SliceItemListRequest",
  "SliceMoqRequest",
  "SliceMOQApprove",
  "SliceRSPChangeRequest",
  'SliceIMPurchaseRequest',
  'SlicePickingList'
];

localForage.config({
  name: "gravity-wms",
  storeName: "reduxPersist" // must be <= 12 chars and lowercase
});

const persistConfig = {
  key: "root",
  // storage,
  storage: localForage,  
  whitelist: reducersToPersist,
};

const reducers = combineReducers({
  login: loginReducer, //login page
  grnModelCheckbox: grnModelCheckboxReducer, //cintentpage
  SliceGRNHead: GrnHeadSlice,
  SliceGRNDetail: GrnDetailSlice,
  grnNavBtn: GrnNavBtnSlice,
  GRNConfiguration: GRNConfigurationSlice,
  SliceGRNLocation: GRNLocationSlice,
  SliceGRNLocationGroup: GRNLocationGroupSlice,
  SliceGRN: GRNSlice,
  GRNDetailValidator: GRNDetailValidatorSlice,
  SliceGRNBinTransferReason: GRNBinTransferReasonSlice,
  SliceBin: BinSlice,
  SliceDriver: SliceDriver,
  SliceWmsDashboard: SliceWmsDashboard,
  SliceTruck: SliceTruck,
  SliceBinTransfer: BinTransferSlice,
  SliceInstantPickingHead: InstantPickingHeadSlice,
  SlicePickingHead: PickingHeadSlice,
  SliceWmsPhysicalStockCount: SliceWmsPhysicalStockCount,
  SliceWmsPoPhysicalStockCount: SliceWmsPoPhysicalStockCount,
  SliceCyclecount: SliceCyclecount,
  SlicePhysicalStock: SlicePhysicalStock,
  SliceStockTransferReceipt: SliceStockTransferReceipt,
  SlicePutAway: SlicePutAway,
  SliceEasyPutAway: SliceEasyPutAway,
  SliceDelivery: SliceDelivery,
  SliceDispatch: SliceDispatch,
  SliceEasyBinTransfer: SliceEasyBinTransfer,
  SliceLoading: SliceLoading,
  SliceEasyLoading: SliceEasyLoading,
  SliceWmsInvoice: WmsInvoiceSlice,
  SliceSalesQuotation: SalesQuotation,
  SliceSalesOrder: SalesOrder,
  SliceSalesInvoice: SliceSalesInvoice,
  SliceSalesReturn: SliceSalesReturn,
  SliceDelieveryNote: SliceDelieveryNote,
  sliceWmsInvoiceTag: WmsInvoiceTagSlice,
  SliceWmsInboundGRN: SliceWmsInboundGRN,
  SliceGRNNormal: SliceGRNNormal,
  SlicePurchaseOrder: SlicePurchaseOrder,
  // SliceGRNNormal: SliceGRNNormal,
  SliceWmsOutboundGRV: SliceWmsOutboundGRV,
  SliceGRV: SliceGRV,
  SliceWmsStockAdjustment: SliceWmsStockAdjustment,
  SliceWmsStockTransfer: SliceWmsStockTransfer,
  SliceStockTransfer: SliceStockTransfer,
  SliceStockAdjustment: SliceStockAdjustment,
  SliceWmsLoadingReceipt: SliceWmsLoadingReceipt,
  Slicebin: Slicebin,
  SliceWMSStockReport: SliceWMSStockReport,
  SliceWMSSalesReport: SliceWMSSalesReport,
  SliceDcCostCompareHistoryReport: SliceDcCostCompareHistoryReport,
  SliceOutletPlanningReport: SliceOutletPlanningReport,
  SlicePendingDoDetailReport: SlicePendingDoDetailReport,
  SliceTransDetailReport: SliceTransDetailReport,
  SliceBinTransferReport: SliceBinTransferReport,
  SliceLoadingList: SliceLoadingList,
  SliceDCRequest: SliceDCRequest,
  SliceNotification: SliceNotification,
  SliceDB: SliceDB,
  SliceSegregation: SliceSegregation,
  SliceWHPicking: SliceWHPicking,
  SliceBarcodeScanning: SliceBarcodeScanning,
  sliceOrderTakingCar,
  sliceCart,
  SliceVendorCreditNote: SliceVendorCreditNote,
  SliceBatchOut: SliceBatchOut,
  SliceItemCreationRequest: SliceItemCreationRequest,
  SliceItemApproveRequest: SliceItemApproveRequest,
  SliceCyclicPhysicalStockSetting: SliceCyclicPhysicalStockSetting,
  SliceCyclicPhysicalStockCounting: SliceCyclicPhysicalStockCounting,
  SliceWmsInboundVendor: SliceWmsInboundVendor,
  SliceWmsInboundReturn: SliceWmsInboundReturn,
  SliceWmsInboundOutlet: SliceWmsInboundOutlet,
  SliceStockTransferRequest: SliceStockTransferRequest,
  SliceStockSetupChangeRequest: SliceStockSetupChangeRequest,
  SliceStockSetupChangeApprove: SliceStockSetupChangeApprove,
  SliceVendorDiscontinueChangeRequest: SliceVendorDiscontinueChangeRequest,
  SliceVendorDiscontinueChangeApprove: SliceVendorDiscontinueChangeApprove,
  SliceItemListApprove: SliceItemListApprove,
  SliceItemListRequest: SliceItemListRequest,
  SliceMoqRequest: SliceMoqRequest,
  SliceMOQApprove: SliceMOQApprove,
  SliceRSPChangeRequest: SliceRSPChangeRequest,
  SliceIMPurchaseRequest: SliceIMPurchaseRequest,
  SlicePickingList:SlicePickingList
});

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  // middleware: [thunk, logger], // Note: logger should be the last item in the middleware
  
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: true,
      // silence non-serializable warnings for redux-persist actions
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(logger), // logger last
});

const persistor = persistStore(store);

export { store, persistor, storage };
